import axios from 'axios'
import queryString from 'query-string'
import { store } from 'src/client'
import {
  AssignCardFeedCardsRequest,
  AssignCardFeedCardsResponse,
  CardFeedEntriesResponse,
  CardFeedResponse,
  CardFeedsResponse,
  CreateCardFeedRequest,
} from 'src/queries/cardFeeds/cardFeeds.models'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

// API max is 100; v1 fetches a single page and shows what fits. Real paging
// is a follow-up.
const CARD_FEEDS_PAGE_SIZE = 100

export const fetchCardFeeds = async (
  organizationId: string,
  page = 0,
): Promise<CardFeedsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const params = queryString.stringify({
    page,
    pageSize: CARD_FEEDS_PAGE_SIZE,
  })
  const response = await axios.get<CardFeedsResponse>(
    `/organizations/${organizationId}/cardfeeds?${params}`,
    requestConfig,
  )
  return response.data
}

export const fetchCardFeed = async (
  organizationId: string,
  cardFeedId: string,
): Promise<CardFeedResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.get<CardFeedResponse>(
    `/organizations/${organizationId}/cardfeeds/${cardFeedId}`,
    requestConfig,
  )
  return response.data
}

export const fetchCardFeedCards = async (
  cardFeedId: string,
  page = 0,
): Promise<CardFeedEntriesResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const params = queryString.stringify({
    page,
    pageSize: CARD_FEEDS_PAGE_SIZE,
  })
  const response = await axios.get<CardFeedEntriesResponse>(
    `/cardfeeds/${cardFeedId}/cards?${params}`,
    requestConfig,
  )
  return response.data
}

export const postAssignCardFeedCards = async (
  cardFeedId: string,
  body: AssignCardFeedCardsRequest,
): Promise<AssignCardFeedCardsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.post<AssignCardFeedCardsResponse>(
    `/cardfeeds/${cardFeedId}/assigncards`,
    body,
    requestConfig,
  )
  return response.data
}

export const postCreateCardFeed = async (
  organizationId: string,
  body: CreateCardFeedRequest,
): Promise<CardFeedResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())
  const response = await axios.post<CardFeedResponse>(
    `/organizations/${organizationId}/cardfeeds`,
    body,
    requestConfig,
  )
  return response.data
}
